import type { FC, PropsWithChildren } from 'react'
import { ScopeProvider } from 'jotai-scope'
import { useCubeContext } from 'modules/Cube/communication/internal/cube.domain.context'
import { phaseExpansionAtom } from './phaseEditor.atoms'
import { getInitialPhaseExpansion } from './phaseEditor.helpers'

/**
 * The editor can rebuild the pricing block during drawer navigation, so
 * expansion lives above the block and survives that remount.
 */
export const PhaseEditorProvider: FC<PropsWithChildren> = ({ children }) => {
  const cubeContext = useCubeContext()
  const initialPhaseExpansion = getInitialPhaseExpansion({
    sortedPhases: cubeContext.queries.orderedPhases,
    amendmentPhaseId: cubeContext.queries.amendment.phaseId,
    highlightedEntityIds:
      cubeContext.queries.rawData.editor.highlightedEntityIds
  })

  return (
    <ScopeProvider atoms={[[phaseExpansionAtom, initialPhaseExpansion]]}>
      {children}
    </ScopeProvider>
  )
}
